import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const trainingAdminRoutes = [
	{
		component: LazyComponent(lazy(() => import('./List'))),
		path: '/training-admin/list',
	},
];

export default trainingAdminRoutes;
